import React, { ReactElement, useContext, useRef, useEffect } from 'react';
import MobileFilters from './MobileFilters';
import Sort from './Sort';
import Filters from './Filters';
import { SearchFacet, SortOption } from 'lib/searchspring/client';
import { ScrollContext } from 'context/ScrollContext';
import { useState } from 'react';

interface FilterSortProps {
  currentSort: SortOption;
  facets: SearchFacet[];
  sortOptions: SortOption[];
  totalResults: number;
  setFilterHeight?: (height: number) => void;
}

export default function FilterSort({
  facets,
  totalResults,
  sortOptions,
  currentSort,
  setFilterHeight,
}: FilterSortProps): ReactElement {
  const ref = useRef<HTMLDivElement>(null);
  const [filterSectionHeight, setFilterSectionHeight] = useState<number>();
  const { setFilterTop, navShowing, stickyFilters, scroll, isMobile, headerHeight } = useContext(
    ScrollContext
  );

  const showSortButton = isMobile ? true : !stickyFilters ? true : false;

  useEffect(() => {
    if (ref.current) {
      // force page to scroll to top when reloaded to ensure
      // the filters section scrolling work properly
      window.onbeforeunload = function () {
        window.scrollTo(0, 0);
      };

      setFilterTop(ref.current.getBoundingClientRect().top as number);
    }
  }, [setFilterTop]);

  useEffect(() => {
    if (ref.current && stickyFilters) {
      setFilterSectionHeight(ref.current.clientHeight);
      if (setFilterHeight) setFilterHeight(ref.current.clientHeight);
    }
  }, [scroll, stickyFilters, setFilterHeight]);

  return (
    <>
      {/* phantom div to stop page jump when filter section becomes fixed */}
      <div
        style={{
          height: filterSectionHeight,
          display: stickyFilters ? 'block' : 'none',
        }}
      ></div>

      {/* Filter and sort section */}
      <div
        ref={ref}
        style={{
          top: navShowing ? headerHeight : 0,
        }}
        className={`bg-white transition-all duration-300 ease-out  ${
          stickyFilters
            ? isMobile
              ? 'fixed inset-x-0 z-50'
              : 'fixed inset-x-0 z-40'
            : 'block inset-x-auto'
        }`}
      >
        <div className={`hidden md:block ${stickyFilters ? '' : 'pt-5'}`}>
          <Filters
            facets={facets}
            totalResults={totalResults}
            sticky={stickyFilters}
            sortOptions={sortOptions}
            currentSort={currentSort}
          />
        </div>
        <div
          className={`flex justify-between md:justify-end items-stretch md:items-center gap-1 px-4 md:p-0 md:mx-32 ${
            showSortButton ? 'mt-5' : ''
          }`}
        >
          {showSortButton && (
            <Sort
              sortOptions={sortOptions}
              currentSort={currentSort}
              sticky={stickyFilters}
              isMobile={isMobile}
            />
          )}
          <MobileFilters facets={facets} />
        </div>
        <div className={`text-center pb-2 mt-2 md:hidden ${stickyFilters ? 'shadow' : ''}`}>
          {totalResults} {totalResults === 1 ? 'Frame' : 'Frames'}
        </div>
      </div>
    </>
  );
}
